module.exports = __webpack_public_path__ + "img/ce77e650.png";